module.exports = __webpack_public_path__ + "img/refresh.80953d4e.svg";